import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
// import { tinyMCE } from '../../../../../config/keys'
import { useClickListener } from './useClickListener'
import EmbeddedAttachmentsSelect from './EmbeddedAttachmentsSelect'
import EmbeddedAnnotationsSelect from './EmbeddedAnnotationsSelect';
import EmbeddedWISelect from './EmbeddedWISelect';
import  AlertDialog  from '../../../../Templates/Dialogue';
import { createModelAnnotation } from '../../../../../util/wi_util';
import { findExtension,isModel, checkNotUndefindeNull,replaceSpanWithTextInString } from '../../../../Templates/functions'
import ReactQuill from 'react-quill';
import { stubTrue } from 'lodash';


 const StepContentEditor = ({updateContent, content, attachments,modelsLoaded, 
    selectedStep,currentStepAttachmentModel, attachmentIndex,viewingAttachment,divStepParent,
    selectedAnnotation,textSelectionRange,annotationHasBeenCreatedPre,saveNewAnnotation,closeOutContentEditor,
    textSelectedInEditor, toggleTextSelectedInEditor,updateEditorRef,hidden, getAnnotationHasBeenCreatedPre,
    getSelectedAnnotation,getTextSelectedInEditor,getAttachmentIndex,getAddedAnnotation,addWILink,
    saveClicked,getCurrentStepAttachmentModel,addAnnotationObjToStepAttachment,isAttachmentModel})=> {
     useClickListener((e) => handleClickOutside(e, handleClickOutside))
    const editorRef = useRef(null);
    // Create a unique ID for this editor instance
    const editorInstanceId = useRef(`editor_${Date.now()}_${Math.random()}`).current;
    const wrapperRef = useRef(null)
    // const [isLoading, setIsLoading] = useState(true)
    //const [value, setValue] = useState(initialValue ?? '');
    const [showingAttachmentMenu, toggleAttachmentMenu] = useState(false)
    const [showingAnnotationtMenu, toggleAnnotationMenu] = useState(false)
    const [showingWIMenu, toggleWIMenu] = useState(false)
    const [anno_array, updateAnno_array] = useState(true)
    let [AttactmentDialog, setAttachmentDialog]  = useState(false)
    const [selectedText,setSelectedText] = useState("")
    let [mouseDown,setMouseDown] = useState(false)
    const [range,setRange] = useState("")
    let [addedAnnotation,setAddedAnnotation] = useState(false)
    let [createAnnotationMode, setCreatAnnotationMode] = useState(false)
    let [linkPositionsArray,setLinkPositionsArray] = useState([])
    let [ed,setEditor] = useState(null)
    let [canDelete,setCanDelete]= useState(true)
    let [canAdd,setCanAdd]= useState(true)
    

    useEffect(() => {
        console.log(`[Editor ${editorInstanceId}] Component mounted, setting up cleanup`);
        return () => {
            console.log(`[Editor ${editorInstanceId}] Component unmounting, unregistering from global registry`);
            
            // Restore tab headers' tabindex before unmounting
            const tabHeaders = document.querySelectorAll('.react-tabs__tab');
            tabHeaders.forEach(tab => {
                const originalTabIndex = tab.getAttribute('data-original-tabindex');
                if (originalTabIndex) {
                    tab.setAttribute('tabindex', originalTabIndex);
                    tab.removeAttribute('data-original-tabindex');
                    console.log(`[Editor ${editorInstanceId}] Restored tabindex on unmount for tab:`, tab.id);
                }
            });
            
            // Unregister from global editor registry
            if (window._editorRegistry) {
                window._editorRegistry.delete(editorInstanceId);
                console.log(`[Editor ${editorInstanceId}] Unregistered from global registry`);
                console.log(`[Global] Remaining editors:`, window._editorRegistry.size);
            }
        }
    }, [editorInstanceId])
    ////////MOVED
    const handleClickOutside = (event) => {
        // Clicking outside now just closes the editor without saving
        // Only the save button will save content
        if (wrapperRef && wrapperRef.current !== event.target && !event.target.innerHTML.includes("tox")) {
            let eventPath = event.composedPath()       
            if (checkNotUndefindeNull(event) && checkNotUndefindeNull(eventPath) && eventPath.length > 0 && eventPath[0] &&
            (String(eventPath[0].id).includes("free-solo-with-text-demo") || (String(eventPath[1].id).includes("webGL-window")) 
            || (String(eventPath[1].id).includes("model-canvas")) || (String(eventPath[1].id).includes("unity-canvas-1")) || 
            (String(eventPath[1].className).includes("tox-tbtn tox-tbtn--select")) || (String(eventPath[1].className).includes("tox-icon tox-tbtn__icon-wrap")) || 
            (String(eventPath[0].id).includes("CloseWIMenuButton")) || (String(eventPath[1].className).includes("EmbeddedWIBUtton")))) {
                return
            } else {
                // Just close the editor without saving
                closeOutContentEditor(false)
            }
        }
        return
    }    
    //////MOVED
    const setupClickListener=()=>{
        // Register this editor in the global registry
        if (!window._editorRegistry) {
            window._editorRegistry = new Map();
            // Set up global click listener only once
            const globalClickHandler = (event) => {
                console.log('[Global] Click detected, checking editors...');
                console.log('[Global] Active element before processing:', document.activeElement);
                console.log('[Global] Click target:', event.target);
                
                // Find which tab panels are in the event path
                const eventPath = event.composedPath ? event.composedPath() : [];
                const tabPanelsInPath = eventPath.filter(element => 
                    element.classList && element.classList.contains('tabPageElement')
                );
                
                console.log('[Global] Tab panels in click path:', tabPanelsInPath.map(tp => tp.id));
                
                window._editorRegistry.forEach((editorInfo, editorId) => {
                    if (editorInfo.handler && editorInfo.isActive) {
                        // Check if this click is outside this specific editor's tab
                        const isClickOutsideThisEditor = !eventPath.some(element => {
                            if (element === editorInfo.tabPanel) return true;
                            if (element === editorInfo.wrapperRef) return true;
                            // Also check for TinyMCE specific elements
                            if (element.id && editorInfo.editorRef && element.id.includes(editorInfo.editorRef.id)) return true;
                            return false;
                        });
                        
                        console.log(`[Global] Click is outside editor ${editorId}:`, isClickOutsideThisEditor);
                        
                        // Only call the handler if the click is outside this editor
                        if (isClickOutsideThisEditor) {
                            console.log(`[Global] Calling handler for editor: ${editorId}`);
                            editorInfo.handler(event);
                        } else {
                            console.log(`[Global] Skipping editor ${editorId} - click is within its tab`);
                        }
                    }
                });
            };
            
            const container = document.getElementById("LeftRightAuthorContainer");
            if (container) {
                container.addEventListener("click", globalClickHandler, true);
                console.log('[Global] Global click listener established');
            }
        }
        
        // Find this editor's tab panel for later reference
        let myTabPanel = null;
        try {
            if (editorRef.current && editorRef.current.getContainer) {
                let current = editorRef.current.getContainer();
                while (current && current.parentElement) {
                    current = current.parentElement;
                    if (current.classList && current.classList.contains('tabPageElement')) {
                        myTabPanel = current;
                        break;
                    }
                }
            }
        } catch (error) {
            console.log(`[Editor ${editorInstanceId}] Error finding tab panel during setup:`, error);
        }
        
        console.log(`[Editor ${editorInstanceId}] My tab panel during setup:`, myTabPanel?.id);
        
        // Register this editor
        window._editorRegistry.set(editorInstanceId, {
            handler: handleClickOutside,
            isActive: true,
            wrapperRef: wrapperRef.current,
            editorRef: editorRef.current,
            tabPanel: myTabPanel
        });
        
        console.log(`[Editor ${editorInstanceId}] Registered in global editor registry`);
        console.log(`[Editor ${editorInstanceId}] Total active editors:`, window._editorRegistry.size);
    }
    ////////MOVED
    const log = (content,dontClose,clickedToggle) => {
        if (editorRef.current) {
            //let editor = editorRef.current.contentWindow.document.querySelector('#tinymce')
            if(content){
                updateContent(content,dontClose,clickedToggle)
            }
            else{
                updateContent(editorRef.current.getContent(),dontClose,clickedToggle)
            }
        }
        let saveButton = document.getElementById("contentEditorSaveButton")
        if(checkNotUndefindeNull(saveButton)){
        }
    };
    //////MOVED
    const fileNames = {}
    attachments.forEach(attachment => {
        let fileName = attachment.path
        if (fileNames[fileName] || !fileName) { return }
        fileNames[fileName] = { title: fileName, id: attachment._id }
    });
    ////////MOVED
    const attachButton = (file) => {
        let editor = editorRef.current.contentWindow.document.querySelector('#tinymce')
        let child = document.createElement('p')
        if(editor.innerText.includes(`![${file.title}::${file.id}]`)){
            setAttachmentDialog (true)
        }
        else{
            child.innerText = `![${file.title}::${file.id}]`
            editor.append(child)
            toggleAttachmentMenu(false)
        }
       
    }

    const SetToClose =()=>{
        toggleAnnotationMenu(false)
        toggleWIMenu(false)
    }
    ///////MOVED
    const attachAnnotationButton = (annotation) => {
        let text = getTextSelectedInEditor()
        let index = getAttachmentIndex()

        let editor = editorRef.current.contentWindow.document.querySelector('#tinymce')
        let child = document.createElement('p')
        if(editor.innerText.includes(`<Annotation,${annotation.Anno_id},${index},${text}.>`)){
            setAttachmentDialog (true)
        }
        else{
            let innerText = editor.innerText

            let range = getRange(editorRef.current)
            let placement = checkPlacement(range,innerText)
            let index = getAttachmentIndex()
                let start = innerText.slice(0,range.start ) //+2
                let end = innerText.slice(range.end) //+2
                editor.innerText = start + `<Annotation,${annotation.Anno_id},${index},${text}.>` + end
                getSetLinkAnnotationPlace(editor.innerText)

                let textToSend = editorRef.current.getContent()
                addAnnotationObjToStepAttachment(annotation,textToSend)
                log(textToSend,true,true) 

        }
       
    }



    const attachWIButton = (wi) => {
        if(checkNotUndefindeNull(wi) && checkNotUndefindeNull(wi.title) && checkNotUndefindeNull(wi.wip_ID) && 
           wi.title.trim().length !== 0 && wi.wip_ID !== null){         
            let editor = editorRef.current.contentWindow.document.querySelector('#tinymce')
            let child = document.createElement('p')
            if(editor.innerText.includes(`<WI,${wi.title},${wi.wip_ID},0.>`)){
                setAttachmentDialog (true)
            }
            else{
                let innerText = editor.innerText
                let range = getRange(ed)
                let placement = checkPlacement(range,innerText)
                    let spl = innerText.split(range.end + placement.rangeToNextSpace)
                    editor.innerText = innerText.slice("0", range.end + placement.rangeToNextSpace) + ` <WI,${wi.title},${wi.wip_ID},0.> ` + innerText.slice(range.end + placement.rangeToNextSpace) + " "
                    getSetLinkAnnotationPlace(editor.innerText)
                    let textToSend = editorRef.current.getContent()
                addWILink(wi)
                log(textToSend,true,true)  
            }
       }
    }
    /////MOVED
    const toggleModel =(text,r) =>{
        setRange(r)
        toggleTextSelectedInEditor(text,r)
    }
    
    //////MOVED
    const modal = (
        <div id="embedded-attachment-autocomplete-form-container" className="flex-apart">
            <EmbeddedAttachmentsSelect
                fileNames={Object.values(fileNames)}
                updateContent={updateContent}
                attachButton={attachButton}
            />
        </div>
    )

    const AnnotationModal=(
        <div id="embedded-attachment-autocomplete-form-container" className="flex-apart">         
         <EmbeddedAnnotationsSelect
            annotations={anno_array}
            updateContent={updateContent}
            attachAnnotationButton={attachAnnotationButton}
        /> 
    </div>
    )

    const WIModal=(
        <div id="embedded-attachment-autocomplete-form-container" className="flex-apart">         
         <EmbeddedWISelect
           // annotations={anno_array}
           // updateContent={updateContent}
            //saveClick={saveClicked}
            attachWIButton={attachWIButton}
            SetToClose={SetToClose}
        />  
    </div>
    )
        //////MOVED
    const selectedAttachmentAnnotations = () =>{
        let attachments = selectedStep.attachments      
        let anno_array = [];
        let count = 1;     
        const currentAttachment = attachments[attachmentIndex || 0]       
        const filename = viewingAttachment || currentAttachment ? currentAttachment.path : ""       
        let ext = findExtension(filename);
        let typeModel = isModel(ext)   
        if (typeModel){
            if (checkNotUndefindeNull(currentAttachment.annotations) && currentAttachment.annotations.length > 0){         
                currentAttachment.annotations.forEach(annotation => {
                    let newAnnotation = {
                        Anno_id :annotation.Anno_id,
                        count : count,
                        attachmentIndex: attachmentIndex,
                        state: JSON.parse(annotation.state)
                    }
                    anno_array.push(newAnnotation)
                    count = count + 1
                })
            } 
        }
        updateAnno_array(anno_array)

    }
    /////MOVED
    const conpareWithAnnotations=(content)=>{
        let contentIsThere = false
        if(checkNotUndefindeNull(attachments[attachmentIndex || 0].annotations ))
        {
          let Annotations = attachments[attachmentIndex || 0].annotations
          if(checkNotUndefindeNull(Annotations)){
            let regExp = new RegExp('\\&lt;Annotation,(.*?),(.*?),(.*?).&gt;','g')      
            let matchesAll = [...content.matchAll(regExp)]
            for(let i =0; i < matchesAll.length; i++ ){
                contentIsThere = false
                Annotations.forEach(anno=>{
                    if (matchesAll[i][1] === anno.Anno_id){
                        contentIsThere = true
                    }
                })
                if(!contentIsThere){
                    content = content.replace(matchesAll[i][0],matchesAll[i][3])
                }
            }          
          }
        }
        return contentIsThere
    }
    //////MOVED
    const SetModelAnnotationTextInContent=()=>{
        let replacementText = `<Annotation,${selectedAnnotation.Anno_id},${attachmentIndex},${textSelectedInEditor}.>`
        editorRef.se.replace(textSelectedInEditor,replacementText)

    }
    /////MOVED
    const SetAnnoatationCreateMode=()=>{
        setCreatAnnotationMode(!createAnnotationMode)
        // useEffect(()=>{setCreatAnnotationMode(!createAnnotationMode)})
    }
    //////MOVED
    const setEditorRef=(EditorRef)=>{
    updateEditorRef(EditorRef) 
    }

    const getAllSpanTags = (text) => {
        let $p = document.createElement('div')
        $p.innerHTML = text;
        if($p.getElementsByTagName('span').length > 0) 
            return $p.getElementsByTagName('span') 
            
        return null;
    }

    const replaceSpan =(editor)=>{
        let content = editor.getContent()
        let s = getAllSpanTags(content)
        if(s != null ){
            for(let i  = 0 ; i< s.length; i++){
                if(s[i].classList.contains("TempHighlight")){
                    let text = s[0].innerText
                    content = content.replace(/<span([^>]*)>.*?<\/span>/g,text)
                    editor.setContent(content)
                }                       
            }

        }
    }

    const startingpPTag=()=>{
        let tag = <p className="" ></p>
        return tag
    }
    
    const getSetLinkAnnotationPlace=(contentE)=>{
        let rangeArray = []
        let rangeArrayObjectA = null
        let rangeArrayObjectS = null
        let rangeArrayObjectW = null
        for (let i = 0; i < contentE.length; i++) {
            if((contentE[i] === "<" && contentE[i + 1] === "A" && contentE[i + 2] === "n" && 
                contentE[i + 3] === "n" && contentE[i + 4] === "o" && contentE[i + 5] === "t" && contentE[i + 6] === "a" && 
                contentE[i + 7] === "t" && contentE[i + 8] === "i" && contentE[i + 9] === "o" && contentE[i + 10] === "n")||
                ///////////////////
                (contentE[i] === "<" && contentE[i + 1] === "s" && contentE[i + 2] === "p" && contentE[i + 3] === "a" && contentE[i] === "n") ||
                ///////////////////
                (contentE[i] === "<" && contentE[i + 1] === "W" && contentE[i + 2] === "I")){
                    if(rangeArrayObjectA == null || rangeArrayObjectS == null){
                        if(contentE[i + 1] === "A" && rangeArrayObjectA == null){
                            rangeArrayObjectA = {}
                            rangeArrayObjectA.start = i 
                            i += 9                                       
                        }
                        else if(contentE[i + 1] === "s" && rangeArrayObjectS === null){
                            rangeArrayObjectS = {}
                            rangeArrayObjectS.start = i 
                            i += 9 
                        }
                        else if(contentE[i + 1] === "W" && rangeArrayObjectW === null){
                            rangeArrayObjectW = {}
                            rangeArrayObjectW.start = i 
                            i += 9 
                        }
                        else{
                           // canHighlight = false
                            break
                        }
 
                    }                             
                }
            else if((contentE[i] === "." && contentE[i + 1] === ">") || 
                    ////////////////
                    (contentE[i] === "<" && contentE[i + 1] === "/" && contentE[i + 2] === "s" && 
                    contentE[i + 3] === "p" && contentE[i + 4] === "a" && contentE[i + 5] === "n")){
                        if(rangeArrayObjectA != null && contentE[i + 1] === ">" ){
                            rangeArrayObjectA.end = i + 2
                            rangeArrayObjectA.text = contentE.substring(rangeArrayObjectA.start, rangeArrayObjectA.end)
                            rangeArray.push(rangeArrayObjectA)
                            rangeArrayObjectA = null
                        }
                        else if(rangeArrayObjectS != null && contentE[i + 1] === "/"){
                            rangeArrayObjectS.end = i + 6
                            rangeArrayObjectS.text = contentE.substring(rangeArrayObjectS.start, rangeArrayObjectS.end)
                            rangeArray.push(rangeArrayObjectS)
                            rangeArrayObjectS = null
                        }
                        else if(rangeArrayObjectW != null && contentE[i - 1] === "0" ){
                            rangeArrayObjectW.end = i + 2
                            rangeArrayObjectW.text = contentE.substring(rangeArrayObjectW.start, rangeArrayObjectW.end)
                            rangeArray.push(rangeArrayObjectW)
                            rangeArrayObjectW = null
                        }
                        else{
                           // canHighlight = false
                            break
                        }
                }

        }

        setLinkPositionsArray(rangeArray)
        console.dir(rangeArray)
        return rangeArray

    }

    // const getRange =(editor)=>{
    //     let range = editor.selection.getRng()   
    //     let parent = range.endContainer.parentNode.offsetParent == null ? range.endContainer.parentNode : range.endContainer.parentNode.offsetParent
    //     let allTextNodes = []
    //     let firstTextNode = false
    //     let allTextNodesAdded = 0

    //     for(let i = 0; parent && i< parent.childNodes.length;i++){
    //         if(parent.childNodes[i].nodeType === 3 || parent.childNodes[i].nodeType === 1)
    //         {
    //             console.dir(parent.childNodes[i])
    //             for(let d = 0;d<parent.childNodes[i].childNodes.length;d++){
    //                 if(parent.childNodes[i].childNodes[d].nodeType === 3 || parent.childNodes[i].childNodes[d].nodeType === 1)
    //                 {
    //                     let c = ""
    //                     if(parent.childNodes[i].childNodes[d].nodeType === 3){
    //                         c = parent.childNodes[i].childNodes[d].data
    //                     }
    //                     else{
    //                         c = parent.childNodes[i].childNodes[d].innerText
    //                     }
    //                     let si = 0
    //                     let ei = 0
    //                     if(c !== ""){
    //                     if(!firstTextNode){
    //                         firstTextNode = true
    //                         ei = c.length - 1
    //                     }
    //                     else{
    //                         si = allTextNodes[allTextNodesAdded - 1].endIndex + 1
    //                         ei = si + c.length 
    //                     }
    //                     allTextNodesAdded += 1
    //                     allTextNodes.push({nodeText: c, startIndex: si, endIndex: ei})
    //                 } 
    //                 } 
    //             }               

    //         }
    //     }
    //     let start = 0
    //     let end = 0
    //     let text = ""
    //     for(let u = 0;u<allTextNodes.length;u++)
    //     {
    //         if (allTextNodes[u].nodeText.includes(range.startContainer.data) ){
    //             start = allTextNodes[u].startIndex + range.startOffset
    //         }
    //         if (allTextNodes[u].nodeText.includes(range.endContainer.data) ){
    //             end = allTextNodes[u].startIndex + range.endOffset
    //         }
    //         text = text + allTextNodes[u].nodeText
    //     }
    //     return({start:start,end:end,text:text})
    // }

    const getRange = (editor) => {
        // Get the complete text content with proper line break handling
        let fullText = editor.getContent({format: 'text'})
        
        // Get the current selection
        let selection = editor.selection
        let range = selection.getRng()
        
        // Use TinyMCE's built-in method to get the selection content
        let selectedText = selection.getContent({format: 'text'})
        
        // Calculate positions using a more reliable method
        let start = 0
        let end = 0
        
        if (selectedText && selectedText.length > 0) {
            // For selections, we need to calculate the position
            // Get all text nodes in the editor body
            let body = editor.getBody()
            let textNodes = []
            let walker = document.createTreeWalker(
                body,
                NodeFilter.SHOW_TEXT,
                null,
                false
            )
            
            let node
            while (node = walker.nextNode()) {
                textNodes.push(node)
            }
            
            // Find the start and end positions
            let currentPos = 0
            let startFound = false
            let endFound = false
            
            for (let i = 0; i < textNodes.length; i++) {
                let textNode = textNodes[i]
                let textLength = textNode.textContent.length
                
                if (textNode === range.startContainer && !startFound) {
                     
                   
                    start = currentPos + range.startOffset
                    startFound = true
                }
                
                if (textNode === range.endContainer && !endFound) {
                    
                     
                    end = currentPos + range.endOffset
                    endFound = true
                    break
                }
                
                currentPos += textLength
            }
            
            // If we didn't find the positions, fall back to a simpler method
            if (!startFound || !endFound) {
                // Use the selection's text to find position in full text
                let beforeText = fullText.substring(0, fullText.indexOf(selectedText))
                start = beforeText.length
                end = start + selectedText.length

            }
        } else {
            // Just cursor position - no selection
            let body = editor.getBody()
            let textNodes = []
            let walker = document.createTreeWalker(
                body,
                NodeFilter.SHOW_TEXT,
                null,
                false
            )
            
            let node
            while (node = walker.nextNode()) {
                textNodes.push(node)
            }
            
            let currentPos = 0
            let cursorPos = 0
            
            for (let i = 0; i < textNodes.length; i++) {
                let textNode = textNodes[i]
                let textLength = textNode.textContent.length
                
                if (textNode === range.startContainer) {
                    cursorPos = currentPos + range.startOffset
                    break
                }
                
                currentPos += textLength
            }
            
            start = cursorPos
            end = cursorPos

        }

        // let lineBreakArray = findLineBreakIndexes(fullText)
        // let startAndEnd = checkStartAndEnd(start,end,lineBreakArray)
        // start = startAndEnd.start
        // end = startAndEnd.end
        
        let newlinecount = countSubstringBeforePosition(fullText, '\n', start)
        let rangeAdhjustment = 0
        if(/\n/.test(fullText)){
            rangeAdhjustment = 1 * newlinecount
        }

        return {
            start: start + rangeAdhjustment,
            end:hasNewlineInSelection(selectedText) ? end + rangeAdhjustment + 1 : end + rangeAdhjustment,
            text: fullText
        }
    }

    const hasNewlineInSelection = (selectedText) => {
      
      
        if (selectedText.rangeCount > 0) {
          
      
          // Check for newline character (\n)
          if (selectedText.includes('\n')) {
            return true;
          }
      
          // Optionally, check for carriage return and newline (\r\n)
          if (selectedText.includes('\r\n')) {
            return true;
          }
        }
      
        return false;
      }


    const countSubstringBeforePosition = (mainString, subString, position) => {
        let count = 0;
        let stringArray = mainString.split('')
        for (let startIndex = 0; startIndex <= position; startIndex++) {   
          if (stringArray[startIndex] == '\n' ) {
            count++;            
          } 
        }
        return count;
      }

    const findLineBreakIndexes = (str) => {
        const charArray = str.split('');
        const lineBreakIndexes = [];
        
        for (let i = 0; i < charArray.length; i++) {
            if (charArray[i] == '\n') {
                lineBreakIndexes.push(i);
            }
        }
        
        return lineBreakIndexes;
    }

    // const checkStartAndEnd = (start,end,lineBreakArray)=>{
    //     let startIsLineBreak = false
    //     let count = 0
    //     let isStartInArray = lineBreakArray.includes(start)
    //     const indexloop = (startIndex,start)=>{
    //         if(lineBreakArray[startIndex] == start + count){
    //             count++
    //             indexloop(startIndex + 1,start)
    //         }
    //         else{
    //             return {start:start + count,end:end + count}
    //         }
    //     }

    //     if(!isStartInArray){
    //         return {start:start,end:end}
    //     }
    //     else{
    //         let startIndex = lineBreakArray.indexOf(start)
    //         count = 1
    //         indexloop(startIndex + 1,start)
    //     }


    // }

    const checkStartAndEnd = (start, end, lineBreakArray) => {
        let adjustedStart = start;
        let adjustedEnd = end;
        
        // Adjust start position if it's on a line break
        while (lineBreakArray.includes(adjustedStart)) {
            adjustedStart++;
        }
        
        return { start: adjustedStart, end: adjustedEnd };
    }


    const checkPlacement=(range,contentE,isJustCursor)=>{
        let selectedRangeEnd = range.end
        let selectedRangeStart = range.start
        let rangeArray = getSetLinkAnnotationPlace(contentE)
        let canAddCheck = true
        let canDeleteCheck = true
        let canHighlight = true                      
        let failIndex = null;       
        if(!isJustCursor){
            for(let j = 0; j < rangeArray.length; j++){
                if ((selectedRangeStart <= rangeArray[j].start && rangeArray[j].end <= selectedRangeEnd)||
                    (selectedRangeStart <= rangeArray[j].start && rangeArray[j].start < selectedRangeEnd && selectedRangeEnd <= rangeArray[j].end)||
                    (rangeArray[j].start <= selectedRangeStart  && selectedRangeStart < rangeArray[j].end && rangeArray[j].end <= selectedRangeEnd)||
                    (rangeArray[j].start <= selectedRangeStart && selectedRangeEnd <= rangeArray[j].end)){
                        canHighlight = false
                        canAddCheck = false
                        canDeleteCheck = false
                        failIndex = j
                        break
                    }
            }
        }
        else{
            for(let j = 0; j < rangeArray.length; j++){
                if((selectedRangeEnd > rangeArray[j].start && rangeArray[j].end >= selectedRangeEnd)){
                        
                        canDeleteCheck = false
                        canAddCheck = false
                        if(rangeArray[j].end >= selectedRangeEnd){
                            canAddCheck = true
                        }
                        break;
                }
            }
        }
        let rangeToNextSpace = 0;

        if(!canHighlight){
            rangeToNextSpace = (rangeArray[failIndex].end - selectedRangeEnd) + 1
        }

        let placementReportObj={
            canHighlight: canHighlight,
            rangeToNextSpace: rangeToNextSpace,
            canAdd:canAddCheck,
            canDelete:canDeleteCheck
        }

        setCanAdd(canAddCheck)
        setCanDelete(canDeleteCheck)
        return placementReportObj;
    }
  
    const tinyEventCallback =(e)=>{
        toggleModel("test")
        return true;
    }

     return  <Fragment>
        {showingAttachmentMenu ? modal : null}
        {showingAnnotationtMenu ? AnnotationModal : null}
        {showingWIMenu ? WIModal : null}
        {AttactmentDialog ? <AlertDialog open={true} alert={"This file is already attached."} confirmAction={()=>setAttachmentDialog(false)} cancel={()=>null} onlyConfirmation={true} /> :null }
        <Editor           
            ref={wrapperRef}
            tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
            hidden={hidden}         
            onInit={(evt, editor) => {
                console.log(`[Editor ${editorInstanceId}] TinyMCE initialized`);
                console.log(`[Editor ${editorInstanceId}] Editor instance:`, editor);
                console.log(`[Editor ${editorInstanceId}] Current document.activeElement:`, document.activeElement);
                console.log(`[Editor ${editorInstanceId}] Editor ID:`, editor.id);
                console.log(`[Editor ${editorInstanceId}] wrapperRef.current at init:`, wrapperRef.current);
                // setIsLoading(false)
                editorRef.current = editor
                editorRef.current.focus()
                setEditor(editor)
                getSetLinkAnnotationPlace(content)
                setupClickListener()
                console.log(`[Editor ${editorInstanceId}] Focus set, activeElement now:`, document.activeElement);
        
        // Add focus/blur tracking
        editor.on('focus', () => {
            console.log(`[Editor ${editorInstanceId}] Editor gained focus, activeElement:`, document.activeElement);
            
            // Temporarily disable tab focusing on tab headers while editing
            const tabHeaders = document.querySelectorAll('.react-tabs__tab');
            tabHeaders.forEach(tab => {
                if (tab.getAttribute('tabindex') !== '-1') {
                    tab.setAttribute('data-original-tabindex', tab.getAttribute('tabindex') || '0');
                    tab.setAttribute('tabindex', '-1');
                    console.log(`[Editor ${editorInstanceId}] Disabled tabindex for tab:`, tab.id);
                }
            });
        });
        
        editor.on('blur', () => {
            console.log(`[Editor ${editorInstanceId}] Editor lost focus, activeElement now:`, document.activeElement);
            
            // Re-enable tab focusing when editor loses focus (but only if we're not stealing it back)
            setTimeout(() => {
                const currentActiveElement = document.activeElement;
                const isTabHeader = currentActiveElement && currentActiveElement.classList.contains('react-tabs__tab');
                
                // Only restore if focus has moved to something that's NOT a tab header
                // (meaning it's a legitimate focus change, not the unwanted tab header steal)
                if (!isTabHeader) {
                    const tabHeaders = document.querySelectorAll('.react-tabs__tab');
                    tabHeaders.forEach(tab => {
                        const originalTabIndex = tab.getAttribute('data-original-tabindex');
                        if (originalTabIndex) {
                            tab.setAttribute('tabindex', originalTabIndex);
                            tab.removeAttribute('data-original-tabindex');
                            console.log(`[Editor ${editorInstanceId}] Restored tabindex for tab:`, tab.id);
                        }
                    });
                }
            }, 100);
        });
        
        // Track keydown events to see what happens during typing
        editor.on('keydown', (e) => {
            console.log(`[Editor ${editorInstanceId}] Key pressed:`, e.key, 'activeElement:', document.activeElement);
            // Prevent event bubbling to parent containers that might interfere with focus
            if (e.originalEvent) {
                e.originalEvent.stopPropagation();
            }
        });
        
        // Also prevent click events from bubbling up
        editor.on('click', (e) => {
            console.log(`[Editor ${editorInstanceId}] Editor clicked, preventing bubbling`);
            if (e.originalEvent) {
                e.originalEvent.stopPropagation();
            }
        });
        
        // Protect against focus loss by re-focusing when needed
        editor.on('focusout', (e) => {
            console.log(`[Editor ${editorInstanceId}] Focus lost (focusout), relatedTarget:`, e.relatedTarget);
            
            // Always check if focus moved to tab headers (regardless of relatedTarget)
            setTimeout(() => {
                const currentActiveElement = document.activeElement;
                const isTabHeader = currentActiveElement && currentActiveElement.classList.contains('react-tabs__tab');
                
                console.log(`[Editor ${editorInstanceId}] Checking focus after focusout, current activeElement:`, currentActiveElement);
                console.log(`[Editor ${editorInstanceId}] Is activeElement a tab header?`, isTabHeader);
                
                if (isTabHeader && editor && !editor.removed) {
                    console.log(`[Editor ${editorInstanceId}] Focus inappropriately moved to tab header, stealing it back!`);
                    editor.focus();
                }
            }, 50); // Slightly longer delay to ensure focus has settled
        });
            }}
            initialValue={content ? content :startingpPTag}
            init={{
                force_br_newlines : false,
                force_p_newlines : false,
                newline_behavior: 'linebreak',
                //extended_valid_elements : "~Annotation,~WI",
                custom_elements: "~Annotation,~WI",
                height: "400px",
                menubar: false,
                placeholder: !content ? "Enter your step content." : "",
               
                setup: function (editor,evt) {
                    let blueBar = document.getElementById("stepContentBlueBar")
                    if(checkNotUndefindeNull(blueBar)){
                        let saveButton = document.createElement("div")
                        saveButton.classList.add("clickable")
                        saveButton.innerText= "Confirm Step Content"
                        saveButton.onclick = () =>{log(null,true,false)}
                        saveButton.id = "contentEditorSaveButton"
                        blueBar.appendChild(saveButton)
                        
                    }
                    if (attachments.length > 0 && !showingAttachmentMenu){
                        editor.ui.registry.addButton('AttachmentLinks', {
                            icon: "link",
                            text: "Attachment Link",
                            onAction: function () {
                                toggleAnnotationMenu(false)
                                toggleWIMenu(false)
                                toggleAttachmentMenu(true)
                            }
                        })
                    }
 
                    editor.on("mousedown",((e)=>{
                        setMouseDown(true)
                    }));

                    editor.on("NodeChange",((e)=>{
                        let highlighted = editor.selection.getContent({format:"text"})
                        if(textSelectedInEditor === highlighted){
                            toggleModel(highlighted , {})
                        }
                        else{
                            
                        }
                     
                    }));

                    editor.on("SelectionChange",((e)=>{
                        let contentE = editor.getContent({format:"text"})
                        getSetLinkAnnotationPlace(contentE)
                        let testRange = getRange(editor)
                        let range = editor.selection.getRng()
                        let canHighlight = checkPlacement(testRange,contentE,range.startOffset === range.endOffset)
                                                 
                    }));

                    editor.on("remove",((e)=>{
                        replaceSpan(editor)
                    }))

                    editor.on("keydown",((e)=>{
                        let contentE = editor.getContent({format:"text"})
                        getSetLinkAnnotationPlace(contentE)
                        let testRange = getRange(editor)
                        let range = editor.selection.getRng()
                        let canHighlight = checkPlacement(testRange,contentE,range.startOffset === range.endOffset)
                        
                        console.dir(e)
                        if(e.code == "Backspace" && !canHighlight.canDelete){
                            e.preventDefault()
                        }
                        if(e.code != "Backspace" && !canHighlight.canAdd){
                            e.preventDefault()
                        }
                    }))

                    editor.on("mouseup",((e)=>{
                        
                            setMouseDown(false)       
                            let highlighted = editor.selection.getContent({format:"text"})  
                            let attach = getCurrentStepAttachmentModel() 
                            let isModel = isAttachmentModel(null,null)                                           
                            if(!mouseDown && highlighted !== "" && modelsLoaded  && isModel)
                            {         
                                let contentE = editor.getContent({format:"text"})
                                let contentD = ""
                                for (let i = 0; i < contentE.length; i++){
                                    if (!(contentE[i] == "\n" || contentE[i] == "\r")){
                                        contentD += contentE[i];
                                    }               
                                }
                  
                                let testRange = getRange(editor)
                                let selectedRangeStart = testRange.start
                                let selectedRangeEnd = testRange.end
                                 ////////////check use to be here
                                 let canHighlight = checkPlacement(testRange,contentE)
                                
                                if(canHighlight.canHighlight){ 
                                   toggleModel(highlighted ,testRange)  
                                }else{
                                    editor.selection.collapse();
                                    alert("the selection can not be used for the annotation")
                                }                                                 
                            }                        
                    }));
                    
                    editor.ui.registry.addButton('WILinks', {
                        icon: "link",
                        text: "WI Link",
                        onAction: function (editor) {                           
                            toggleAnnotationMenu(false)
                            toggleAttachmentMenu(false)
                            toggleWIMenu(!showingWIMenu)
                            
                        }
                    })

                    editor.ui.registry.addButton('Save', {
                        icon: "checkmark",
                        text: "Save Annotation",
                        style: 'color:green',
                        onAction: function () {
                            let created = getAnnotationHasBeenCreatedPre()
                            let text = getTextSelectedInEditor()
                            let annotation = getSelectedAnnotation()
                            let index = getAttachmentIndex()
                            let isModel = isAttachmentModel(null,null)
                            
                            // Validate annotation exists before trying to use it
                            if (!annotation) {
                                alert("Please click on the 3D model to place the annotation marker before saving.");
                                return;
                            }
                            
                            if (created && isModel){
                                // editor.selection.setContent("", {format: 'raw'}) 
                                let testRange = getRange(editor)                                
                                let editorC = editorRef.current.contentWindow.document.querySelector('#tinymce');
                                let innerText = editorC.innerText
                                let child = document.createElement('p');
                                if (editorC.innerText.includes(`<Annotation,${annotation.Anno_id},${index},${text}.>`)) {
                                  setAttachmentDialog(true);
                                } else {
                                    createModelAnnotation(annotation).then((data)=>{
                                        attachAnnotationButton(data.data)
                                    }).catch((e)=>{
                                        alert("There was an error creating this Model Annotation.")
                                    })

                                }                        
                            }
                            
                        }
                    });

                    editor.ui.registry.addToggleButton('CreateAnnotation', {
                        icon: "plus",
                        tooltip: "Create Annotation",
                        style: `color:${createAnnotationMode?"green": "grey"}`,
                        onAction: function () {                  
                            SetAnnoatationCreateMode()
                        }
                    });
                },
                statusbar: false,
                selector: "textarea",               
                plugins: [
                    'advlist autolink lists link image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen',
                    // 'formatpainter',
                    'table',
                    'media',
                    'fullscreen'
                ],
                contextmenu: false,
                // contextmenu_never_use_native: true,  CreateAnnotation
                toolbar: 'WILinks |AnnotationLinks  | Save  | formatselect | ' +
                'bold italic underline subscript superscript |' +
                // 'forecolor backcolor formatpainter removeformat|' +
                'forecolor backcolor removeformat|' +
                'alignleft aligncenter alignright|' + 
                'bullist numlist outdent indent | ' +
                // 'print preview media' +
                //| Save
                '| table | fullscreen | undo redo AttachmentLinks ',
                table_toolbar: 'table |' +
                // 'tableprops'
                // 'tablerowprops tablecellprops | 
                'tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol | tabledelete', 
                table_default_attributes: { border: '1'},
                content_style: 'body { font-family:Futura; font-size:15px }',
            }}
        />
       
    </Fragment>
}


export default StepContentEditor
